// extracted by mini-css-extract-plugin
export var container = "autonomy-module--container--jG8wR";
export var flex = "autonomy-module--flex--cxlZJ";
export var item_container = "autonomy-module--item_container--GniXY";
export var number = "autonomy-module--number--Cgb4Q";